import axios from 'axios';
import { getAuthHeader } from "../utils/authHelper.js";


const getAvailablePrinters = async (division, warehouse) => {
  
  try {
     const apiCall = axios.create({
   baseURL:
     process.env.REACT_APP_API_URL +
     `ReturnPrinters/${division}/${warehouse}`,
   headers: await getAuthHeader(),
 });

    const response = await apiCall.get();
    return response.data.Value;
  } catch (error) {
    return error;
  }
};

const getSkuInfo = async (division, sku) => {
   const apiCall = axios.create({
   baseURL:
     process.env.REACT_APP_API_URL +
     `GetSku/${division}/${sku}`,
   headers: await getAuthHeader(),
 });
  return apiCall.get()
    .then((response) => response.data.Value)
    .catch((err) => {
      console.log(err);
    });
};

const postReturnOrders = async (
  division,
  warehouse,
  employeeId,
  returnLines,
  orderNumber,
  route,
  printer,
  shipDate
) => {
  const filteredReturnLines = returnLines.map((line) => {
    return {
      SkuNumber: line.SkuNumber,
      ReturnQuantity: line.ReturnQuantity,
      SkuCorrection: line.SkuCorrection ? line.SkuCorrection : null,
      SkuCorrectionQuantity: line.SkuCorrectionQuantity
        ? line.SkuCorrectionQuantity
        : null,
      Unexpected: line.Unexpected ? line.Unexpected : 'NotSet',
    };
  });
  const data = {
    Division: division,
    WarehouseNumber: warehouse,
    EV3Number: employeeId,
    RouteNumber: route,
    ReturnLines: filteredReturnLines,
    OrderNumber: orderNumber,
    Printer: printer,
    ShipDate: shipDate,
  };
   const apiCall = axios.create({
   baseURL:
     process.env.REACT_APP_API_URL,
   headers: await getAuthHeader(),
 });
  return apiCall
    .post('PostReturnOrders', data)
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      return error.response;
    });
};

const closeRoute = async (postData) => {
  const apiCall = axios.create({
   baseURL:
     process.env.REACT_APP_API_URL,
   headers: await getAuthHeader(),
 });

  return apiCall
    .post(`CloseRoute`, postData)
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      return error.response.data;
    });
};

const printRoute = async (postData) => {
  const apiCall = axios.create({
   baseURL:
     process.env.REACT_APP_API_URL,
   headers: await getAuthHeader(),
 });
  return apiCall
    .post(`PrintRoute`, postData)
    .then((response) => response.data)
    .catch((error) => {
      console.error(error);
      return error.response;
    });
};

const OrderServices = {
  getAvailablePrinters,
  postReturnOrders,
  getSkuInfo,
  closeRoute,
  printRoute,
};

export default OrderServices;
